import { LRS_ACTIONS, LRS_OBJECT_TYPES } from '@techchange/components';
import { messages } from '../../../i18n';

/**
 * Maps actions to internationalized labels.
 *
 * @param {Object} intl    The provider for internationalization.
 *
 * @returns {Object} Mapping of LRS action names to set of internationalized labels.
 */
function getIntlActions(intl) {

	// TODO: should pass in all possible UI labels (e.g. past tense, etc.)
	return {
		[LRS_ACTIONS.ATTENDED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_ATTENDED),
			value: LRS_ACTIONS.ATTENDED
		},
		[LRS_ACTIONS.CLICKED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CLICKED),
			value: LRS_ACTIONS.CLICKED
		},
		[LRS_ACTIONS.COMPLETED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_COMPLETED),
			value: LRS_ACTIONS.COMPLETED
		},
		[LRS_ACTIONS.CREATED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_CREATED),
			value: LRS_ACTIONS.CREATED
		},
		[LRS_ACTIONS.EARNED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_EARNED),
			value: LRS_ACTIONS.EARNED
		},
		[LRS_ACTIONS.FINISHED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_FINISHED),
			value: LRS_ACTIONS.FINISHED
		},
		[LRS_ACTIONS.MARKED_COMPLETE]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_SELF_COMPLETED),
			value: LRS_ACTIONS.MARKED_COMPLETE,
		},
		[LRS_ACTIONS.PASSED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PASSED),
			value: LRS_ACTIONS.PASSED,
		},
		[LRS_ACTIONS.PAUSED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PAUSED),
			value: LRS_ACTIONS.PAUSED,
		},
		[LRS_ACTIONS.PLAYED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_PLAYED),
			value: LRS_ACTIONS.PLAYED,
		},
		[LRS_ACTIONS.RSVPED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_RSVPED),
			value: LRS_ACTIONS.RSVPED
		},
		[LRS_ACTIONS.VIEWED]: {
			label: intl && intl.formatMessage(messages.TC_COMPONENTS_GENERAL_TEXT_LRS_ACTION_VIEWED),
			value: LRS_ACTIONS.VIEWED
		},
	};

}

/**
 * Maps actions to corresponding metadata.
 *
 * @param {Object} intl    The provider for internationalization.
 *
 * @returns {Object} Mapping of actions to corresponding metadata.
 */
export default function getActionMap(intl) {

	const {
		[LRS_ACTIONS.ATTENDED]: attended,
		[LRS_ACTIONS.CLICKED]: clicked,
		[LRS_ACTIONS.COMPLETED]: completed,
		[LRS_ACTIONS.CREATED]: created,
		[LRS_ACTIONS.EARNED]: earned,
		[LRS_ACTIONS.FINISHED]: finished,
		[LRS_ACTIONS.MARKED_COMPLETE]: markedComplete,
		[LRS_ACTIONS.PASSED]: passed,
		[LRS_ACTIONS.PAUSED]: paused,
		[LRS_ACTIONS.PLAYED]: played,
		[LRS_ACTIONS.RSVPED]: rsvped,
		[LRS_ACTIONS.VIEWED]: viewed,
	} = getIntlActions(intl);

	return {
		[LRS_OBJECT_TYPES.CERTIFICATE]: [earned],
		[LRS_OBJECT_TYPES.DISCUSSION_COMMENT]: [created],
		[LRS_OBJECT_TYPES.DISCUSSION_THREAD]: [created],
		[LRS_OBJECT_TYPES.EMBED]: [markedComplete],
		[LRS_OBJECT_TYPES.EVENT]: [attended, rsvped],
		[LRS_OBJECT_TYPES.FORM_ENTRY]: [created],
		[LRS_OBJECT_TYPES.FORM]: [markedComplete],
		[LRS_OBJECT_TYPES.LINK]: [clicked],
		[LRS_OBJECT_TYPES.IMAGE]: [clicked, markedComplete],
		[LRS_OBJECT_TYPES.MIRO]: [markedComplete],
		[LRS_OBJECT_TYPES.PAGE]: [completed],
		[LRS_OBJECT_TYPES.POINT]: [earned],
		[LRS_OBJECT_TYPES.POLL]: [markedComplete],
		[LRS_OBJECT_TYPES.QUIZ]: [passed, markedComplete],
		[LRS_OBJECT_TYPES.SESSION]: [completed],
		[LRS_OBJECT_TYPES.SLIDE]: [viewed, markedComplete],
		[LRS_OBJECT_TYPES.VIDEO]: [played, paused, finished, markedComplete],
	};

}
